// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorPayouts = (client) => ({
    /**
     * `GET /vendor/payouts`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListPayouts
     * @source packages/modules/b2c-core/src/api/vendor/payouts/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/payouts", { method: "GET", query, headers }),
});
//# sourceMappingURL=payouts.js.map